import { OperationAlertDeliveryGroup } from "../../../types/alert/operation-alert-delivery-group";
import { AlertState } from "../../type/alert-state";

interface Action {
  type: string;
  payload: {
    schedulesNotStarted: OperationAlertDeliveryGroup[];
    deliveryGroupsExpectedToBeDelayed: OperationAlertDeliveryGroup[];
    deliveryGroupsCompletedWithDelay: OperationAlertDeliveryGroup[];
    deliveryGroupsCompletedWithoutImage: OperationAlertDeliveryGroup[];
  };
}

export const setAlertDispatch = (state: AlertState, action: Action) => {
  const {
    schedulesNotStarted,
    deliveryGroupsExpectedToBeDelayed,
    deliveryGroupsCompletedWithDelay,
    deliveryGroupsCompletedWithoutImage,
  } = action.payload;

  state.allAlerts.schedulesNotStarted = schedulesNotStarted;
  state.allAlerts.deliveryGroupsExpectedToBeDelayed =
    deliveryGroupsExpectedToBeDelayed;
  state.allAlerts.deliveryGroupsCompletedWithDelay =
    deliveryGroupsCompletedWithDelay;
  state.allAlerts.deliveryGroupsCompletedWithoutImage =
    deliveryGroupsCompletedWithoutImage;
};
